"use client";

import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

/**
 * Live citation generator embedded on the Court Case landing page. The tool opens straight
 * on the manual-entry tab preset to the "Court case" source type (CSL `legal_case`), whose
 * fields map to the Bluebook elements — case name, volume, reporter, page, court, year.
 * Users fill those in and pick any of the 10,834 styles — no engine change.
 */
export default function CourtCaseCitationGeneratorWidget() {
  return (
    <CitationTool
      initialManualType="legal_case"
      initialMode="manual"
      styles={getFeaturedStyles()}
    />
  );
}
